import { createMuiTheme } from '@material-ui/core/styles';

import { PRIMARY_COLOR, SECONDARY_COLOR } from '../utils';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: PRIMARY_COLOR,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: SECONDARY_COLOR,
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  overrides: {
    MuiAppBar: {
      root: {
        border: 0,
      },
    },
    // O AutocompleteInput do react-admin (v3) fixa zIndex: 2 no Popper da lista de
    // sugestões — abaixo do zIndex: 1300 (theme.zIndex.modal) usado por Drawer/Dialog do
    // MUI, então dentro de um Drawer (ex: "Filtros avançados") a lista renderiza atrás
    // dele. RaAutocompleteSuggestionList é o nome de classe que o próprio react-admin
    // registra via makeStyles, o ponto de override suportado pra isso.
    RaAutocompleteSuggestionList: {
      suggestionsContainer: {
        zIndex: 1400,
      },
    },
  },
  sidebar: {
    //width: 250,
    //closedWidth: 70,
  },
});

export default theme;
